import React, { useState, useEffect } from 'react'
import { Spin, Pagination, message, Input, Select, AutoComplete } from 'antd'
import JobsTable from './JobsTable'
import UseDebounce from '../../helpers/UseDebounce'
import { getListJob } from '../../../services/api/apiJobs'

function JobsPage() {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(20)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [jobSearch, setJobSearch] = useState('')
    const [creator, setCreator] = useState('')
    const [jobSystem, setJobSystem] = useState('')
    const [jobService, setJobService] = useState('')
    const [jobStatus, setJobStatus] = useState('')

    const debounceJobSearch = UseDebounce(jobSearch, 1000)
    const debounceCreator = UseDebounce(creator, 1000)
    const debounceJobSystem = UseDebounce(jobSystem, 1000)
    const debounceJobService = UseDebounce(jobService, 1000)

    const { Option } = Select

    const fetchData = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            const query = {}
            if (jobSearch) query.number = debounceJobSearch.trim()
            if (jobSystem) query.system = jobSystem.trim()
            if (jobService) query.service = jobService.trim()
            if (jobStatus) query.status = jobStatus
            if (creator) query.created_by = debounceCreator.trim()

            if (Object.keys(query).length > 0) {
                payload.query = query
            }


            const { success, data = {}, message: mess } = await getListJob(payload)
            if (!success) {
                throw new Error(mess)
            }
            setData(data.jobs)
            setTotal(data.total)
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [debounceJobSearch, debounceCreator, debounceJobSystem, debounceJobService, jobStatus, page, limit])

    const handleChangeInput = (field, value) => {
        if (field === 'job') setJobSearch(value)
        if (field === 'creator') setCreator(value)
        setPage(1)
    }

    const handleChangeSelect = (field, value) => {
        if (field === 'system') setJobSystem(value)
        if (field === 'service') setJobService(value)
        if (field === 'status') setJobStatus(value)
        setPage(1)
    }

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const systemOptions = ['FAC', '3D', 'FFM'].sort().map(i => ({
        value: i,
        label: i,
    }))

    const serviceOptions = ['3d-api', 'exporter-service', 'fulfillment-service'].sort().map(i => ({
        value: i,
        label: i,
    }))

    return (
        <div className='JobsPage'>
            <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                <h1 className="PageTitle font-weight-bold mb-0">Danh sách Job</h1>
                <div className="RightTop">
                </div>
            </div>
            <div className="SectionInner mt-3 card px-3 py-3">
                <div className="filter align-items-center mt-2">
                    <div className="Filter">
                        <div className="d-flex flex-wrap justify-content-start">
                            <div className="FilterWrapper FilterOptions mr-2 mb-3">
                                <div className="CustomSelect d-flex align-items-stretch justify-content-end">
                                    <Input
                                        style={{ width: "400px" }}
                                        placeholder='Search: Job '
                                        onChange={(e) => handleChangeInput('job', e.target.value)}
                                        allowClear
                                        disabled={loading}
                                        value={jobSearch || ''}
                                    />
                                </div>
                            </div>

                            <div className='CustomSelect FilterOptions mr-2 mb-3'>
                                <Input
                                    style={{ minWidth: "200px" }}
                                    placeholder="Search: Người tạo"
                                    allowClear
                                    disabled={loading}
                                    onChange={(e) => handleChangeInput('creator', e.target.value)}
                                    value={creator || ''}
                                />
                            </div>

                            <div className='CustomSelect FilterOptions mr-2 mb-3'>
                                <AutoComplete
                                    allowClear
                                    placeholder="-- Hệ thống --"
                                    value={jobSystem || ''}
                                    onChange={(value, e) => handleChangeSelect('system', value)}
                                    style={{ minWidth: '200px' }}
                                    options={systemOptions}
                                    filterOption={(inputValue, option) =>
                                        !!option && option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    disabled={loading}
                                />
                            </div>

                            <div className='CustomSelect FilterOptions mr-2 mb-3'>
                                <AutoComplete
                                    allowClear
                                    placeholder="-- Service --"
                                    value={jobService || ''}
                                    onChange={(value, e) => handleChangeSelect('service', value)}
                                    style={{ minWidth: '200px' }}
                                    options={serviceOptions}
                                    filterOption={(inputValue, option) =>
                                        !!option && option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    disabled={loading}
                                />
                            </div>
                            <div className='CustomSelect FilterOptions mr-2 mb-3'>
                                <Select
                                    style={{ minWidth: "200px" }}
                                    placeholder="-- Trạng thái --"
                                    allowClear
                                    value={jobStatus || []}
                                    onChange={e => handleChangeSelect('status', e)}
                                    disabled={loading}
                                >
                                    <Option value='success'>Success</Option>
                                    <Option value='error'>Error</Option>
                                    <Option value='processing'>Processing</Option>
                                    <Option value='queued'>Queued</Option>
                                    <Option value='pending'>Pending</Option>
                                    <Option value='cancelled'>Cancelled</Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    <div>
                        <div className='SkuTotal d-flex justify-content-between align-items-center mb-3'>
                            <div className='d-flex align-content-center'>
                            </div>
                            {
                                total > 0 && <div>
                                    <span className='font-weight-bold'>{total}</span> {total !== 1 ? 'jobs' : 'job'}
                                </div>
                            }
                        </div>
                        <Spin spinning={loading} tip='Data Loading...'>
                            <JobsTable
                                data={data}
                                loading={loading}
                                reset={fetchData}
                            />
                            <Pagination
                                pageSizeOptions={['10', '20', '50', '100']}
                                onChange={handlePageChange}
                                className='text-right'
                                pageSize={limit}
                                showSizeChanger
                                current={page}
                                total={total}
                            />
                        </Spin>
                    </div>
                }
            </div>
        </div>
    )
}

export default JobsPage